<template>
  <div class="pre-checkin-form-wrapper">
    <b-card>
      <!-- <div class="wrapper">
      <button @click="this.$parent.showCamera = false" class="button-close">x</button>
       <button class="button-snap" @click="toggleCamera()">
        <span v-if="!isCameraOpen">Open Camera</span>
        <span v-else>Close Camera</span>
      </button>
       <div class="video-container">
        <video v-show="isCameraOpen" class="camera-video" ref="camera" :width="450" :height="337" autoplay playsinline ></video>
        <canvas id="photoTaken" v-show="isPhotoTaken" class="canvas-photo" ref="canvas" :width="450" :height="337"></canvas>
      </div>
       <button v-if="!isPhotoTaken && isCameraOpen" class="button-snap" @click="takePhoto">
        <span>Snap!</span>
      </button>
      <button v-show="isPhotoTaken && isCameraOpen" class="camera-download">
        <a id="downloadPhoto" download="VueRocksPhoto.jpg" class="button" role="button" @click="downloadImage">
          Download
        </a>
      </button>

    </div> -->
      <template #header>
        <h2 class="mb-0">{{ $t('pre_checkin.advanced_title') }}</h2>
      </template>
      <div v-if="isFullyLoading" class="text-center p-5">
        <b-spinner class="mb-2" />
        <div>{{ $t('pre_checkin.loading') }}</div>
      </div>
      <div v-else-if="notFoundError" class="text-center p-5">
        <b-alert show variant="danger">
          <i class="fas fa-exclamation-triangle"></i>
          {{ notFoundMessage }}
        </b-alert>
      </div>
      <div v-else>
        <div v-if="isPreCheckinSubmitted && !isEditing" class="p-4">
          <b-alert show variant="info" class="mb-4">
            <i class="fas fa-info-circle"></i> {{ $t('pre_checkin.already_submitted') }}
          </b-alert>
          <b-button variant="primary" class="mb-3" v-if="booking.reservation_status == 'booked'" @click="startEdit"
            :disabled="isCheckoutDatePassed">
            <i class="fas fa-edit"></i> {{ $t('common.edit') }}
          </b-button>
          <div v-if="isCheckoutDatePassed" class="text-muted small">
            <i class="fas fa-info-circle"></i>
            {{ $t('pre_checkin.edit_disabled_after_checkout') || 'Editing is disabled after checkout date' }}
          </div>

          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-hotel"></i> {{ $t('pre_checkin.booking_information')
                }}</span>
            </template>
            <b-row>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.booking_id') }}:</span> <span class="value">{{
                booking.id
                  }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.hotel_name') }}:</span> <span class="value">{{
                booking.hotel }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.checkin') }}:</span> <span class="value">{{
                booking.checkin
                  }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.checkout') }}:</span> <span class="value">{{
                booking.checkout }}</span></b-col>
            </b-row>
            <div class="mt-2">
              <span class="label">{{ $t('pre_checkin.room_summary') }}:</span> <span class="value">{{
                booking.roomSummary
                }}</span>
            </div>
          </b-card>


          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-plane-arrival"></i> {{ $t('pre_checkin.arrival_information')
                }}</span>
            </template>
            <b-row>
              <b-col md="4"><span class="label">{{ $t('pre_checkin.estimated_arrival_time') }}:</span> <span
                  class="value">{{
                    preCheckinData.arrival_time }}</span></b-col>
              <b-col md="4"><span class="label">{{ $t('pre_checkin.mode_of_arrival') }}:</span> <span class="value">{{
                preCheckinData.arrival_mode
                  }}</span></b-col>
              <b-col md="4"><span class="label">{{ $t('pre_checkin.special_instructions') }}:</span> <span
                  class="value">{{
                    preCheckinData.arrival_instructions }}</span></b-col>
            </b-row>
          </b-card>


          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-bed"></i> {{ $t('pre_checkin.preferences') }}</span>
            </template>
            <b-row>
              <b-col md="4"><span class="label">{{ $t('pre_checkin.bed_preference') }}:</span> <span class="value">{{
                preCheckinData.bed_preference
                  }}</span></b-col>
              <b-col md="4"><span class="label">{{ $t('pre_checkin.smoking_preference') }}:</span> <span
                  class="value">{{
                    preCheckinData.smoking_preference }}</span></b-col>
              <b-col md="4">
                <span class="label">{{ $t('pre_checkin.checkin_options') }}:</span>
                <span class="value">Late: {{ preCheckinData.late_checkin ? 'Yes' : 'No' }}, Early: {{
                  preCheckinData.early_checkin ? 'Yes' : 'No' }}</span>
              </b-col>
            </b-row>
            <div class="mt-2">
              <span class="label">{{ $t('pre_checkin.special_requests') }}:</span> <span class="value">{{
                preCheckinData.special_requests
                }}</span>
            </div>
          </b-card>


          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-user-shield"></i> {{ $t('pre_checkin.emergency_contact')
                }}</span>
            </template>
            <b-row>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.name') }}:</span> <span class="value">{{
                preCheckinData.emergency_name
                  }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.relationship') }}:</span> <span class="value">{{
                preCheckinData.emergency_relationship }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.phone') }}:</span> <span class="value">{{
                preCheckinData.emergency_phone
                  }}</span></b-col>
              <b-col md="3"><span class="label">{{ $t('pre_checkin.email') }}:</span> <span class="value">{{
                preCheckinData.emergency_email
                  }}</span></b-col>
            </b-row>
          </b-card>

          <!-- 
          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-credit-card"></i> Payment Information</span>
            </template>
            <b-row>
              <b-col md="3"><span class="label">Status:</span> <span class="value">{{ preCheckinData.payment_status
              }}</span></b-col>
              <b-col md="3"><span class="label">Method:</span> <span class="value">{{ preCheckinData.payment_method
              }}</span></b-col>
              <b-col md="2"><span class="label">Paid:</span> <span class="value">{{ preCheckinData.amount_paid
              }}</span></b-col>
              <b-col md="2"><span class="label">Due:</span> <span class="value">{{ preCheckinData.balance_due
              }}</span></b-col>
              <b-col md="2"><span class="label">GST:</span> <span class="value">{{ preCheckinData.gst_number
              }}</span></b-col>
            </b-row>
            <div class="mt-2">
              <span class="label">Company Name:</span> <span class="value">{{ preCheckinData.company_name }}</span>
            </div>
          </b-card> -->


          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-clipboard-check"></i> {{
                $t('pre_checkin.declarations_signature') }}</span>
            </template>
            <div class="mb-2">
              <span class="label">{{ $t('pre_checkin.agreed_to_hotel_policies') }}:</span> <span class="value">{{
                preCheckinData.agreed ? 'Yes'
                  :
                  'No'
              }}</span><br>
              <span class="label">{{ $t('pre_checkin.confirmed_details_accuracy') }}:</span> <span class="value">{{
                preCheckinData.confirmed ?
                  'Yes' :
                  'No' }}</span>
            </div>
            <div v-if="preCheckinData.signature_data" class="signature-display text-center">
              <img :src="preCheckinData.signature_data" alt="Guest Signature" class="signature-image shadow">
            </div>
            <div v-else class="text-muted text-center">
              {{ $t('pre_checkin.no_signature_provided') }}
            </div>
          </b-card>


          <b-card class="mb-4 section-card">
            <template #header>
              <span class="section-title"><i class="fas fa-users"></i> {{ $t('pre_checkin.guest_details') }}</span>
            </template>
            <div v-if="rooms && rooms.length > 0">
              <div v-for="(room, rIdx) in rooms" :key="rIdx" class="mb-3">
                <div class="guest-room-title mb-2">
                  <i class="fas fa-door-open"></i> {{ $t('pre_checkin.room') }} {{ rIdx + 1 }}: {{ room.type }} <span
                    v-if="room.number">({{
                      room.number
                    }})</span>
                </div>
                <div class="guest-cards-row">
                  <div v-for="(guest, gIdx) in room.guests" :key="gIdx" class="guest-mini-card">
                    <div class="guest-mini-header">
                      <i class="fas fa-user"></i>
                      <span class="guest-mini-name">{{ guest.name }}</span>
                    </div>
                    <div class="guest-mini-info">
                      <span><b>{{ $t('pre_checkin.dob') }}:</b> {{ guest.dob }}</span>
                      <span><b>{{ $t('pre_checkin.gender') }}:</b> {{ guest.gender }}</span>
                      <span><b>{{ $t('pre_checkin.passport') }}:</b> {{ guest.passportId }}</span>
                      <div v-if="guest.passportImageUrl" class="mt-2">
                        <div class="passport-label">{{ $t('pre_checkin.passport_image') }}:</div>
                        <img :src="guest.passportImageUrl" class="doc-thumb" alt="Passport" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-muted">
              {{ $t('pre_checkin.no_guest_details_available') }}
            </div>
          </b-card>
        </div>

        <b-form v-else @submit.prevent="isEditing ? handleEditSubmit() : handleSubmit()" novalidate>
          <b-alert v-if="formErrors['rooms']" show variant="danger" class="mb-2">
            {{ formErrors['rooms'][0] }}
          </b-alert>
          <h4 class="mb-3">{{ $t('pre_checkin.booking_information') }}</h4>
          <b-row>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.booking_id')"><b-form-input :value="booking.id"
                  readonly /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.hotel_name')"><b-form-input :value="booking.hotel"
                  readonly /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.checkin')"><b-form-input :value="booking.checkin"
                  readonly /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.checkout')"><b-form-input :value="booking.checkout"
                  readonly /></b-form-group></b-col>
          </b-row>
          <b-form-group :label="$t('pre_checkin.room_summary')">
            <b-form-textarea :value="booking.roomSummary" readonly rows="2" />
          </b-form-group>

          <h4 class="mb-3">{{ $t('pre_checkin.guest_details') }}</h4>
          <div v-for="(room, rIdx) in rooms" :key="rIdx" class="mb-4 p-3 border rounded bg-light">
            <h5>{{ $t('pre_checkin.room') }} {{ rIdx + 1 }}: {{ room.type }} <span v-if="room.number">({{ room.number
                }})</span></h5>
            <b-alert v-if="formErrors['rooms.' + rIdx + '.guests']" show variant="danger" class="mb-2">
              {{ formErrors['rooms.' + rIdx + '.guests'][0] }}
            </b-alert>
            <div v-for="(guest, gIdx) in room.guests" :key="gIdx" class="mb-3 p-2 border rounded">
              <b-row>
                <b-col md="2">
                  <b-form-group :label="$t('pre_checkin.passport_image')">
                    <div class="d-flex flex-column gap-2">
                      <!-- Action Dropdown -->
                      <b-dropdown text="Upload Passport" variant="primary" size="sm" class="w-50">
                        <!-- <b-dropdown-item @click="openCamera(rIdx, gIdx)">📷 Take Photo</b-dropdown-item> -->
                        <b-dropdown-item @click="() => triggerFileInput(rIdx, gIdx)">📁 Choose File</b-dropdown-item>
                      </b-dropdown>

                      <!-- Hidden File Input -->
                      <input type="file" :id="`passportFile-${rIdx}-${gIdx}`" accept="image/*" class="d-none"
                        @change="e => handleGuestPassportUpload(rIdx, gIdx, e)" />

                      <!-- Camera Preview (shown only for active guest) -->
                      <div v-if="activeCameraForGuest === `${rIdx}-${gIdx}`" class="camera-preview mt-2">
                        <video :ref="`camera_${rIdx}_${gIdx}`" autoplay playsinline class="camera-video" width="450"
                          height="337"></video>

                        <canvas :ref="`canvas_${rIdx}_${gIdx}`" width="450" height="337" style="display:none;"></canvas>



                        <div class="camera-controls mt-2">
                          <b-button variant="success" size="sm" @click="capturePhoto(rIdx, gIdx)">
                            <i class="fas fa-camera"></i> Capture
                          </b-button>
                          <b-button variant="danger" size="sm" @click="closeCamera" class="ml-2">
                            <i class="fas fa-times"></i> Cancel
                          </b-button>
                        </div>
                      </div>

                      <!-- Preview of captured/uploaded image -->
                      <div v-if="guest.passportPreview" class="mt-3">
                        <img :src="guest.passportPreview" class="doc-thumb border rounded shadow-sm" alt="Passport" />
                      </div>
                    </div>
                  </b-form-group>

                </b-col>
                <b-col md="3">
                  <b-form-group :label="$t('pre_checkin.full_name')">
                    <b-form-input v-model="guest.name"
                      :state="getFieldState('rooms.' + rIdx + '.guests.' + gIdx + '.name')"
                      :name="`rooms.${rIdx}.guests.${gIdx}.name`" />
                    <b-form-invalid-feedback v-if="formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.name']">
                      {{ formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.name'][0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group :label="$t('pre_checkin.dob')">
                    <b-form-input v-model="guest.dob" type="date"
                      :state="getFieldState('rooms.' + rIdx + '.guests.' + gIdx + '.dob')"
                      :name="`rooms.${rIdx}.guests.${gIdx}.dob`" />
                    <b-form-invalid-feedback v-if="formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.dob']">
                      {{ formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.dob'][0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group :label="$t('pre_checkin.gender')">
                    <b-form-select v-model="guest.gender" :options="genderOptions"
                      :state="getFieldState('rooms.' + rIdx + '.guests.' + gIdx + '.gender')"
                      :name="`rooms.${rIdx}.guests.${gIdx}.gender`" />
                    <b-form-invalid-feedback v-if="formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.gender']">
                      {{ formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.gender'][0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group :label="$t('pre_checkin.passport_id')">
                    <b-form-input v-model="guest.passportId"
                      :state="getFieldState('rooms.' + rIdx + '.guests.' + gIdx + '.passportId')"
                      :name="`rooms.${rIdx}.guests.${gIdx}.passportId`" />
                    <b-form-invalid-feedback v-if="formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.passportId']">
                      {{ formErrors['rooms.' + rIdx + '.guests.' + gIdx + '.passportId'][0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="text-right">
                <b-button v-if="room.guests.length > 1" size="sm" variant="outline-danger"
                  @click="confirmRemoveGuest(rIdx, gIdx)">
                  <i class="fas fa-trash"></i> {{ $t('common.remove_guest') }}
                </b-button>
              </div>
            </div>
            <b-button size="sm" variant="outline-primary" @click="addGuest(rIdx)"
              :disabled="room.guests.length >= (room.capacity || 1)" v-if="room.guests.length < (room.capacity || 1)">
              <i class="fas fa-plus"></i> {{ $t('common.add_guest') }}
            </b-button>
          </div>

          <h4 class="mb-3">{{ $t('pre_checkin.arrival_information') }}</h4>
          <b-row>
            <b-col md="4"><b-form-group :label="$t('pre_checkin.estimated_arrival_time')"><b-form-timepicker
                  v-model="arrival.time" :state="!formErrors['arrival.time']" /></b-form-group>
              <b-form-invalid-feedback :state="!formErrors.has('arrival.time')">
                {{ formErrors.first('arrival.time') }}
              </b-form-invalid-feedback>
            </b-col>

            <b-col md="4"><b-form-group :label="$t('pre_checkin.mode_of_arrival')"><b-form-select v-model="arrival.mode"
                  :options="arrivalModeOptions" :state="!formErrors['arrival.mode']" /></b-form-group>
              <b-form-invalid-feedback :state="!formErrors.has('arrival.mode')">
                {{ formErrors.first('arrival.mode') }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="4"><b-form-group :label="$t('pre_checkin.special_arrival_instructions')"><b-form-textarea
                  v-model="arrival.instructions" rows="2"
                  :state="!formErrors['arrival.instructions']" /></b-form-group></b-col>
          </b-row>
          <b-form-invalid-feedback v-if="formErrors['arrival.time']">
            {{ formErrors['arrival.time'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['arrival.mode']">
            {{ formErrors['arrival.mode'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['arrival.instructions']">
            {{ formErrors['arrival.instructions'][0] }}
          </b-form-invalid-feedback>

          <h4 class="mb-3">{{ $t('pre_checkin.preferences') }}</h4>
          <b-row>
            <b-col md="4"><b-form-group :label="$t('pre_checkin.bed_preference')"><b-form-select
                  v-model="preferences.bed" :options="bedOptions"
                  :state="!formErrors['preferences.bed']" /></b-form-group></b-col>
            <b-col md="4"><b-form-group :label="$t('pre_checkin.smoking_preference')"><b-form-select
                  v-model="preferences.smoking" :options="smokingOptions"
                  :state="!formErrors['preferences.smoking']" /></b-form-group></b-col>
            <b-col md="4">
              <b-form-group>
                <b-form-checkbox v-model="preferences.lateCheckin" :state="!formErrors['preferences.lateCheckin']">{{
                  $t('pre_checkin.late_checkin') }}</b-form-checkbox>
                <b-form-checkbox v-model="preferences.earlyCheckin" :state="!formErrors['preferences.earlyCheckin']">{{
                  $t('pre_checkin.early_checkin') }}</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-invalid-feedback v-if="formErrors['preferences.bed']">
            {{ formErrors['preferences.bed'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['preferences.smoking']">
            {{ formErrors['preferences.smoking'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['preferences.lateCheckin']">
            {{ formErrors['preferences.lateCheckin'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['preferences.earlyCheckin']">
            {{ formErrors['preferences.earlyCheckin'][0] }}
          </b-form-invalid-feedback>
          <b-form-group :label="$t('pre_checkin.special_requests')">
            <b-form-textarea v-model="preferences.specialRequests" rows="2"
              :state="!formErrors['preferences.specialRequests']" />
          </b-form-group>
          <b-form-invalid-feedback v-if="formErrors['preferences.specialRequests']">
            {{ formErrors['preferences.specialRequests'][0] }}
          </b-form-invalid-feedback>

          <!-- Pre-Checkin Offers Section -->
          <h4 class="mb-3">
            <i class="fas fa-gift text-warning"></i>
            {{ $t('pre_checkin.special_offers') || 'Special Offers' }}
            <small class="text-muted">({{ $t('pre_checkin.offers_optional') || 'Optional' }})</small>
            <span v-if="isEditing" class="badge badge-info ml-2">
              <i class="fas fa-edit"></i> Editing Mode - Offers can be changed
            </span>
          </h4>

          <!-- Loading Offers -->
          <div v-if="isLoadingOffers" class="text-center p-4">
            <b-spinner class="mb-2" />
            <div>{{ $t('pre_checkin.loading_offers') || 'Loading special offers...' }}</div>
            <div v-if="isEditing" class="text-muted small mt-2">
              <i class="fas fa-info-circle"></i> Checking for updated offers...
            </div>
          </div>

          <!-- No Offers Available -->
          <div v-else-if="availableOffers.length === 0" class="text-center p-4">
            <i class="fas fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
            <div class="text-muted">{{ $t('pre_checkin.no_offers_available') || 'No special offers available at this time.' }}
            </div>
            <div v-if="isEditing && preCheckinData?.offer_id" class="text-muted small mt-2">
              <i class="fas fa-info-circle"></i> Your previously applied offer will be maintained.
            </div>
          </div>

          <!-- Available Offers -->
          <div v-else class="offers-container">
            <div class="offers-grid">
              <div v-for="offer in availableOffers" :key="offer.id" class="offer-card-compact"
                :class="{ 'offer-selected': selectedOffer?.id === offer.id }">
                <div class="offer-content">
                  <div class="offer-header">
                    <h6 class="offer-title-compact">{{ offer.name }}</h6>
                    <div class="offer-badge-compact">
                      <i class="fas fa-gift"></i>
                      {{ offer.precheckin_discount_type === 'percentage' ? offer.value + '% OFF' :
                        offer.precheckin_discount_type === 'fixed' ? '₹' + offer.value + ' OFF' :
                          offer.precheckin_discount_type === 'free_night' ? 'FREE NIGHT' : 'SPECIAL OFFER' }}
                    </div>
                  </div>
                  <!-- Show indicator for previously applied offer -->
                  <div v-if="isEditing && selectedOffer?.id === offer.id && preCheckinData?.offer_id === offer.id"
                    class="offer-previously-applied">
                    <i class="fas fa-check-circle text-success"></i>
                    <small class="text-muted">Previously Applied</small>
                  </div>
                  <p class="offer-description-compact" v-html="offer.description"></p>

                  <div class="offer-pricing">
                    <div class="price-row">
                      <span class="price-label">Original:</span>
                      <span class="price-original">₹{{ booking.total_price }}</span>
                    </div>
                    <div class="price-row">
                      <span class="price-label">Booking Discount:</span>
                      <span class="price-discount">-₹{{ booking.discount_amount }}</span>
                    </div>
                    <div class="price-row">
                      <span class="price-label">Save:</span>
                      <span class="price-discount">-₹{{ calculateOfferDiscount(offer) }}</span>
                    </div>
                    <div class="price-row final">
                      <span class="price-label">Final:</span>
                      <span class="price-final">₹{{ calculateFinalPrice(offer) }}</span>
                    </div>
                  </div>

                  <div class="offer-validity">
                    <i class="fas fa-clock"></i>
                    {{ formatValidUntil(offer) }}
                  </div>
                </div>

                <div class="offer-action">
                  <b-button v-if="selectedOffer?.id !== offer.id" variant="outline-primary" size="sm"
                    @click="selectOffer(offer)" :disabled="isSubmitting" class="btn-compact">
                    <i class="fas fa-check"></i> Select
                  </b-button>
                  <b-button v-else variant="outline-danger" size="sm" @click="clearSelectedOffer"
                    :disabled="isSubmitting" class="btn-compact">
                    <i class="fas fa-times"></i> Remove
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <h4 class="mb-3">{{ $t('pre_checkin.emergency_contact') }}</h4>
          <b-row>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.name')"><b-form-input v-model="emergency.name" required
                  :state="!formErrors['emergency.name']" /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.relationship')"><b-form-input
                  v-model="emergency.relationship" required
                  :state="!formErrors['emergency.relationship']" /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.phone')"><b-form-input v-model="emergency.phone"
                  required :state="!formErrors['emergency.phone']" /></b-form-group></b-col>
            <b-col md="3"><b-form-group :label="$t('pre_checkin.email')"><b-form-input v-model="emergency.email"
                  type="email" :state="!formErrors['emergency.email']" /></b-form-group></b-col>
          </b-row>
          <b-form-invalid-feedback v-if="formErrors['emergency.name']">
            {{ formErrors['emergency.name'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['emergency.relationship']">
            {{ formErrors['emergency.relationship'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['emergency.phone']">
            {{ formErrors['emergency.phone'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['emergency.email']">
            {{ formErrors['emergency.email'][0] }}
          </b-form-invalid-feedback>

          <!-- <h4 class="mb-3">Payment Information</h4>
          <b-row>
            <b-col md="3">
              <b-form-group label="Payment Status">
                <b-form-select v-model="payment.status" :options="paymentStatusOptions" required
                  :state="!formErrors['payment.status']" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Payment Method">
                <b-form-select v-model="payment.method" :options="paymentMethodOptions" required
                  :state="!formErrors['payment.method']" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Amount Paid">
                <b-form-input v-model="payment.amountPaid" type="number" min="0" required
                  :state="!formErrors['payment.amountPaid']" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Balance Due">
                <b-form-input v-model="payment.balanceDue" type="number" min="0" required
                  :state="!formErrors['payment.balanceDue']" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="GST Number (optional)">
                <b-form-input v-model="payment.gstNumber" :state="!formErrors['payment.gstNumber']" />
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-form-invalid-feedback v-if="formErrors['payment.status']">
            {{ formErrors['payment.status'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['payment.method']">
            {{ formErrors['payment.method'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['payment.amountPaid']">
            {{ formErrors['payment.amountPaid'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['payment.balanceDue']">
            {{ formErrors['payment.balanceDue'][0] }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="formErrors['payment.gstNumber']">
            {{ formErrors['payment.gstNumber'][0] }}
          </b-form-invalid-feedback>
          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('pre_checkin.company_name') + ' (if applicable)'"><b-form-input
                  v-model="payment.companyName" :state="!formErrors['payment.companyName']" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-invalid-feedback v-if="formErrors['payment.companyName']">
            {{ formErrors['payment.companyName'][0] }}
          </b-form-invalid-feedback>

          <h4 class="mb-3">{{ $t('pre_checkin.declarations_confirmation') }}</h4>
          <b-form-checkbox v-model="declarations.confirmed" required :state="getFieldState('declarations.confirmed')">
            {{ $t('pre_checkin.confirm_details_accurate') }}

          </b-form-checkbox>
          <b-form-invalid-feedback v-if="formErrors['declarations.confirmed']" class="invalid-feedback d-block">
            {{ formErrors['declarations.confirmed'][0] }}
          </b-form-invalid-feedback>

          <b-form-checkbox v-model="declarations.agree" required :state="getFieldState('declarations.agree')">
            {{ $t('pre_checkin.agree_hotel_policies') }}
          </b-form-checkbox>
          <b-form-invalid-feedback v-if="formErrors['declarations.agree']" class="invalid-feedback d-block">
            {{ formErrors['declarations.agree'][0] }}
          </b-form-invalid-feedback>
          <b-form-group :label="$t('pre_checkin.signature')">
            <div class="signature-pad-container">
              <canvas id="signature-pad" class="signature-pad"></canvas>
            </div>
            <b-form-invalid-feedback :state="!formErrors.has('signature')">
              {{ formErrors.first('signature') }}
            </b-form-invalid-feedback>
            <div class="text-right mt-2">
              <b-button size="sm" variant="outline-secondary" @click="clearSignature">
                {{ $t('common.clear_signature') }}
              </b-button>
            </div>
          </b-form-group>
          <div class="text-right mt-2">
            <b-button type="submit" variant="success" :disabled="isSubmitting">
              <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
              {{ isSubmitting ? $t('common.saving') : (isEditing ? $t('common.save_changes') : $t('common.submit')) }}
            </b-button>
            <b-button v-if="isEditing" variant="secondary" class="ml-2" @click="isEditing = false"
              :disabled="isSubmitting">
              {{ $t('common.cancel') }}
            </b-button>
          </div>
          <div v-if="formLevelError" class="mt-3">
            <b-alert show variant="danger">{{ formLevelError }}</b-alert>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import { request } from '@/Util/Request';
import Error from '@/Util/Error';

const GENDER_OPTIONS = [
  { value: '', text: 'Select Gender' },
  { value: 'male', text: 'Male' },
  { value: 'female', text: 'Female' },
  { value: 'other', text: 'Other' }
];
const ARRIVAL_MODE_OPTIONS = [
  { value: '', text: 'Select Mode' },
  { value: 'car', text: 'Car' },
  { value: 'taxi', text: 'Taxi' },
  { value: 'bus', text: 'Bus' },
  { value: 'train', text: 'Train' },
  { value: 'flight', text: 'Flight' }
];
const BED_OPTIONS = [
  { value: '', text: 'No Preference' },
  { value: 'king', text: 'King' },
  { value: 'twin', text: 'Twin' }
];
const SMOKING_OPTIONS = [
  { value: '', text: 'No Preference' },
  { value: 'smoking', text: 'Smoking' },
  { value: 'non-smoking', text: 'Non-Smoking' }
];

export default {
  name: 'PreCheckinForm',
  data() {
    return {
      guestsToDelete: [],
      isSubmitting: false,
      isFullyLoading: true,
      isPreCheckinStatusLoading: true,
      isLoading: true,
      formLevelError: '',
      isPreCheckinSubmitted: false,
      preCheckinData: null,
      isEditing: false,
      notFoundError: false,
      notFoundMessage: '',
      formErrors: new Error({}),
      booking: {
        id: '',
        hotel: '',
        checkin: '',
        checkout: '',
        roomSummary: ''
      },
      rooms: [],
      genderOptions: GENDER_OPTIONS,
      arrivalModeOptions: ARRIVAL_MODE_OPTIONS,
      bedOptions: BED_OPTIONS,
      smokingOptions: SMOKING_OPTIONS,
      arrival: {
        time: '',
        mode: '',
        instructions: ''
      },
      preferences: {
        bed: '',
        smoking: '',
        lateCheckin: false,
        earlyCheckin: false,
        specialRequests: ''
      },
      emergency: {
        name: '',
        relationship: '',
        phone: '',
        email: ''
      },
      declarations: {
        confirmed: '',
        agree: ''
      },
      signaturePad: null,
      payment: {
        status: '',
        method: '',
        amountPaid: '',
        balanceDue: '',
        gstNumber: '',
        companyName: ''
      },
      paymentStatusOptions: [
        { value: '', text: 'Select Payment Status' },
        { value: 'paid', text: 'Paid' },
        { value: 'unpaid', text: 'Unpaid' },
        { value: 'partiallyPaid', text: 'Partially Paid' }
      ],
      paymentMethodOptions: [
        { value: '', text: 'Select Payment Method' },
        { value: 'upi', text: 'UPI' },
        { value: 'card', text: 'Card' },
        { value: 'cash', text: 'Cash' },
        { value: 'netBanking', text: 'Net Banking' }
      ],
      // Pre-Checkin Offers
      isLoadingOffers: false,
      availableOffers: [],
      selectedOffer: null,
      activeCameraForGuest: null,
      cameraStream: null,
    };
  },
  computed: {
    isCheckoutDatePassed() {
      console.log('Checking checkout date:', this.booking);

      if (!this.booking?.check_out) return false;
      const checkoutDate = new Date(this.booking.check_out);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day
      return checkoutDate < today;
    }
  },
  watch: {
    isFullyLoading(newVal) {
      if (!newVal && !this.isPreCheckinSubmitted && !this.isEditing) {
        // Form is now visible for first pre-checkin
        this.$nextTick(() => {
          this.initSignaturePad();
        });
      }
    },
    isEditing(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initSignaturePad(this.preCheckinData?.signature_data);
        });
      }
    }
  },
  async mounted() {
    const bookingId = this.$route.params.id;
    this.isFullyLoading = true;
    await Promise.all([
      this.fetchBooking(),
      this.checkPreCheckinStatus(bookingId)
    ]);
    this.isFullyLoading = false;
    this.initSignaturePad();
    window.addEventListener('resize', this.resizeCanvas);

    // Load available offers for pre-checkin
    if (!this.isPreCheckinSubmitted) {
      await this.loadAvailableOffers();
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
    if (this.signaturePad) {
      this.signaturePad.off();
    }
  },
  methods: {
    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true
      })

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.$refs.camera.srcObject = stream
        })
        .catch(error => {
          alert(error, "May the browser didn't support or there is some errors.")
        })
    },
    stopCameraStream() {
      const tracks = this.$refs.camera.srcObject.getTracks()

      tracks.forEach(track => {
        track.stop()
      })
      console.log('CameraClosed')
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false
        this.isPhotoTaken = false
        this.stopCameraStream()
        console.log('closed');
      } else {
        this.isCameraOpen = true
        this.createCameraElement()
        console.log('open');
      }
    },
    takePhoto() {
      this.isPhotoTaken = !this.isPhotoTaken

      const context = this.$refs.canvas.getContext('2d')
      const photoFromVideo = this.$refs.camera

      context.drawImage(photoFromVideo, 0, 0, 450, 337)
    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },
    triggerFileInput(rIdx, gIdx) {
      this.$nextTick(() => {
        const fileInput = document.getElementById(`passportFile-${rIdx}-${gIdx}`);
        if (fileInput) {
          fileInput.click();
        } else {
          console.error('File input not found for guest', rIdx, gIdx);
          this.$bvToast.toast('Failed to access file input', {
            variant: 'danger',
            solid: true
          });
        }
      });
    },

    closeCamera() {
      console.log("Closing camera for guest:", this.cameraStream);

      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(track => track.stop());
        this.cameraStream = null;
      }
      this.activeCameraForGuest = null;
    },
    async openCamera(rIdx, gIdx) {
      this.activeCameraForGuest = `${rIdx}-${gIdx}`;
      try {
        this.cameraStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false
        });

        let videoRef = this.$refs[`camera_${rIdx}_${gIdx}`];
        const video = Array.isArray(videoRef) ? videoRef[0] : videoRef;

        if (video) {
          video.srcObject = this.cameraStream;
        } else {
          console.error("Video element not found:", videoRef);
        }
      } catch (err) {
        alert("Camera not accessible: " + err.message);
        this.activeCameraForGuest = null;
      }
    },



    capturePhoto(rIdx, gIdx) {
      // Use a more reliable way to get the refs
      // Ensure the element is rendered and available in the DOM
      this.$nextTick(() => {
        let videoRef = this.$refs[`camera_${rIdx}_${gIdx}`];
        let canvasRef = this.$refs[`canvas_${rIdx}_${gIdx}`];
        console.log("Refs for camera and canvas:", videoRef, canvasRef);

        const video = (Array.isArray(videoRef) ? videoRef[0] : videoRef) || null;
        const canvas = (Array.isArray(canvasRef) ? canvasRef[0] : canvasRef) || null;
        console.log("Video and Canvas elements:", video, canvas);

        if (!canvas || !video) {
          console.error("Video/Canvas element not found. Check if the camera preview is visible.");
          // The camera preview isn't visible, so we can't capture a photo.
          return;
        }

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = canvas.toDataURL("image/jpeg");
        console.log("Photo captured and preview set for guest:", this.guests);

        // Make sure the rooms and guest object exist before setting the preview
        if (
          this.rooms[rIdx] &&
          this.rooms[rIdx].guests &&
          this.rooms[rIdx].guests[gIdx]
        ) {
          this.$set(this.rooms[rIdx].guests[gIdx], 'passportPreview', imageData);
        } else {
          console.error("Guest object not found for index", rIdx, gIdx);
        }
        console.log("Photo captured and preview set for guest:", rIdx, gIdx);

        this.closeCamera();
      });
    },

    getFieldState(field) {
      if (this.formErrors[field]) return false;


      return null;
    },
    async startEdit() {
      this.isEditing = true;

      // Load offers first if not already loaded
      if (this.availableOffers.length === 0) {
        await this.loadAvailableOffers();
      }

      this.$nextTick(() => {
        this.initSignaturePad(this.preCheckinData.signature_data);
        this.populateFormFromPreCheckin();
      });
    },
    populateFormFromPreCheckin() {
      if (!this.preCheckinData) return;
      this.arrival = {
        time: this.preCheckinData.arrival_time || '',
        mode: this.preCheckinData.arrival_mode || '',
        instructions: this.preCheckinData.arrival_instructions || ''
      };
      this.preferences = {
        bed: this.preCheckinData.bed_preference || '',
        smoking: this.preCheckinData.smoking_preference || '',
        lateCheckin: !!this.preCheckinData.late_checkin,
        earlyCheckin: !!this.preCheckinData.early_checkin,
        specialRequests: this.preCheckinData.special_requests || ''
      };
      this.emergency = {
        name: this.preCheckinData.emergency_name || '',
        relationship: this.preCheckinData.emergency_relationship || '',
        phone: this.preCheckinData.emergency_phone || '',
        email: this.preCheckinData.emergency_email || ''
      };
      this.payment = {
        status: this.preCheckinData.payment_status || '',
        method: this.preCheckinData.payment_method || '',
        amountPaid: this.preCheckinData.amount_paid || '',
        balanceDue: this.preCheckinData.balance_due || '',
        gstNumber: this.preCheckinData.gst_number || '',
        companyName: this.preCheckinData.company_name || ''
      };
      this.declarations = {
        confirmed: !!this.preCheckinData.confirmed,
        agree: !!this.preCheckinData.agreed
      };

      // Restore selected offer if it exists
      if (this.preCheckinData.offer_id && this.availableOffers.length > 0) {
        this.selectedOffer = this.availableOffers.find(o => o.id === this.preCheckinData.offer_id);
      }

      if (this.signaturePad && this.preCheckinData.signature_data) {
        this.signaturePad.clear();
        this.signaturePad.fromDataURL(this.preCheckinData.signature_data);
      }
    },
    async checkPreCheckinStatus(token) {
      this.isPreCheckinStatusLoading = true;
      try {
        const response = await request({
          method: 'get',
          url: `/pre-check-in/check/${token}`,
        });
        if (response && response.data) {
          this.isPreCheckinSubmitted = true;
          this.preCheckinData = response.data;

          // Set selected offer if one was applied
          if (response.data.offer_id && response.data.offer) {
            this.selectedOffer = response.data.offer;
          }

          // Load available offers for editing
          if (this.booking?.precheckin_token) {
            await this.loadAvailableOffers();
          }
        }
      } catch (e) {
        this.isPreCheckinSubmitted = false;
        this.preCheckinData = null;
      } finally {
        this.isPreCheckinStatusLoading = false;
      }
    },
    async fetchBooking() {
      this.isLoading = true;
      this.notFoundError = false;
      this.notFoundMessage = '';
      try {
        const bookingId = this.$route.params.id;
        const response = await request({
          method: 'get',
          url: `/bookings/precheckin/${bookingId}`
        });
        if (response && response.data) {
          const b = response.data;
          this.booking = {
            id: b.id,
            hotel: b.hotel?.name || '',
            checkin: b.check_in,
            checkout: b.check_out,
            total_price: b.total_price,
            discount_amount: b.discount_amount,
            precheckin_token: b.precheckin_token,
            reservation_status: b.reservation_status,
            roomSummary: (b.booking_room_types || [])
              .map(rt => `${rt.num_of_rooms}x ${rt.room_type?.name || ''}`)
              .join(', ')
          };
          this.rooms = [];
          (b.booking_room_types || []).forEach(rt => {
            if (rt.booking_room && Array.isArray(rt.booking_room)) {
              rt.booking_room.forEach(room => {
                this.rooms.push({
                  id: room.id || '',
                  type: rt.room_type?.name || '',
                  number: room.room?.room_number || '',
                  capacity: rt.room_type.capacity || 1,
                  guests: (room.guests || []).map(g => {
                    let passportImageUrl = '';
                    if (Array.isArray(g.passportImageUrl) && g.passportImageUrl.length > 0) {
                      passportImageUrl = g.passportImageUrl[0].path;
                    }
                    return {
                      id: g.id || '',
                      booking_room_type_room_id: g.booking_room_type_room_id || '',
                      name: g.name || '',
                      dob: g.date_of_birth || '',
                      gender: g.gender || '',
                      passportId: g.passport_number || '',
                      passportImage: null,
                      passportPreview: passportImageUrl,
                      passportImageUrl: passportImageUrl
                    };
                  })
                });
              });
            }
          });
        } else {
          this.notFoundError = true;
          this.notFoundMessage = 'No booking found for this pre-checkin link.';
        }
      } catch (e) {
        this.notFoundError = true;
        this.notFoundMessage =
          (e.response && e.response.data && e.response.data.message)
            ? e.response.data.message
            : 'No booking found for this pre-checkin link.';
        this.formLevelError = 'Failed to load booking data.';
      } finally {
        this.isLoading = false;
      }
    },
    addGuest(roomIdx) {
      this.rooms[roomIdx].guests.push({
        name: '',
        dob: '',
        gender: '',
        passportId: '',
        passportImage: null,
        passportPreview: '',
        passportImageUrl: ''
      });
    },
    confirmRemoveGuest(roomIdx, guestIdx) {
      if (window.confirm('Are you sure you want to remove this guest?')) {
        const guest = this.rooms[roomIdx].guests[guestIdx];
        if (guest.id) {
          this.guestsToDelete.push(guest.id);
        }
        this.rooms[roomIdx].guests.splice(guestIdx, 1);
      }
    },
    async handleGuestPassportUpload(roomIdx, guestIdx, event) {
      const file = event.target.files[0];
      if (!file) return;
      const guest = this.rooms[roomIdx].guests[guestIdx];
      guest.passportImage = file;
      const reader = new FileReader();
      reader.onload = e => {
        guest.passportPreview = e.target.result;
        guest.passportImageBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append('passport_image', file);
      try {
        const response = await request({
          method: 'post',
          url: '/passport-ocr',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log("OCR response:", response);
        
        if (Response) {
          guest.passportId = response.passport_number || '';
          guest.name = response.given_names || '';
          if(response.gender) {
            if(response.gender == "M"){
              guest.gender = "male";
            } else {
              guest.gender = "female";
            }
          }

          if( response.date_of_birth) {
            const dateParts = response.date_of_birth.split('/');
            if (dateParts.length === 3) {
              guest.dob = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // Convert to YYYY-MM-DD
            } else {
              guest.dob = response.date_of_birth; // Fallback if format is unexpected
            }
          }
          // guest.dob = response.date_of_birth || '';
        }
      } catch (e) {
        this.formLevelError = 'OCR extraction failed. Please fill the details manually.';
      }
    },
    initSignaturePad(signatureVector = null) {
      const canvas = document.getElementById('signature-pad');
      if (canvas) {
        this.resizeCanvas(canvas);
        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });
        if (signatureVector) {
          try {
            this.signaturePad.fromData(JSON.parse(signatureVector));
          } catch (e) {
            this.signaturePad.fromDataURL(signatureVector);
          }
        }
      }
    },
    resizeCanvas(canvas) {
      if (!canvas || !canvas.parentElement) return;
      const parent = canvas.parentElement;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = parent.offsetWidth * ratio;
      canvas.height = parent.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    },
    clearSignature() {
      if (this.signaturePad) {
        this.signaturePad.clear();
      }
    },
    async handleSubmit() {
      console.log("this.selectedOffer?.id", this.selectedOffer?.id);

      this.formLevelError = '';
      this.formErrors = new Error({});
      this.isSubmitting = true;

      let guestError = false;
      this.rooms.forEach((room, rIdx) => {
        room.guests.forEach((guest, gIdx) => {
          if (!guest.name) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.name`, ['Name is required']);
            guestError = true;
          }
          if (!guest.dob) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.dob`, ['Date of birth is required']);
            guestError = true;
          }
          if (!guest.gender) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.gender`, ['Gender is required']);
            guestError = true;
          }
          if (!guest.passportId) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.passportId`, ['Passport ID is required']);
            guestError = true;
          }

        });
      });
      if (!this.declarations.confirmed) {
        this.$set(this.formErrors, 'declarations.confirmed', ['You must confirm the details are accurate.']);
        guestError = true;
      }
      if (!this.declarations.agree) {
        this.$set(this.formErrors, 'declarations.agree', ['You must agree to the hotel\'s policies.']);
        guestError = true;
      }

      if (guestError) {
        this.isSubmitting = false;

        this.$nextTick(() => {
          const firstErrorKey = Object.keys(this.formErrors)[0];
          if (firstErrorKey) {

            const input = document.querySelector(`[name='${firstErrorKey}']`);
            if (input) {
              input.scrollIntoView({ behavior: 'smooth', block: 'center' });
              input.focus();
            }
          }
        });

        this.$bvToast.toast('Please fix the errors in the form.', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      const payload = {
        rooms: this.rooms,
        arrival: this.arrival,
        preferences: this.preferences,
        emergency: this.emergency,
        payment: this.payment,
        declarations: this.declarations,
        signature: this.signaturePad && !this.signaturePad.isEmpty()
          ? this.signaturePad.toDataURL('image/png')
          : null,
        selected_offer_id: this.selectedOffer?.id || null,
      };
      try {
        const response = await request({
          method: 'post',
          url: `/pre-check-in/${this.$route.params.id}`,
          data: payload,
        });
        this.preCheckinData = response.data;
        this.isPreCheckinSubmitted = true;
        await this.fetchBooking();
        this.$bvToast.toast(
          `Pre-checkin ${this.$route.params.id} submitted successfully!`,
          {
            title: "Success",
            variant: "success",
          }
        );
      } catch (error) {
        if (error.request?.status === 422) {
          this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
          return false;
        } else {
          this.formLevelError = 'Failed to submit pre-checkin. Please try again.';
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    async handleEditSubmit() {
      this.formLevelError = '';
      this.formErrors = new Error({});
      this.isSubmitting = true;
      let guestError = false;
      this.rooms.forEach((room, rIdx) => {
        room.guests.forEach((guest, gIdx) => {
          if (!guest.name) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.name`, ['Name is required']);
            guestError = true;
          }
          if (!guest.dob) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.dob`, ['Date of birth is required']);
            guestError = true;
          }
          if (!guest.gender) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.gender`, ['Gender is required']);
            guestError = true;
          }
          if (!guest.passportId) {
            this.$set(this.formErrors, `rooms.${rIdx}.guests.${gIdx}.passportId`, ['Passport ID is required']);
            guestError = true;
          }

        });
      });
      if (!this.declarations.confirmed) {
        this.$set(this.formErrors, 'declarations.confirmed', ['You must confirm the details are accurate.']);
        guestError = true;
      }
      if (!this.declarations.agree) {
        this.$set(this.formErrors, 'declarations.agree', ['You must agree to the hotel\'s policies.']);
        guestError = true;
      }

      if (guestError) {
        this.isSubmitting = false;

        this.$nextTick(() => {
          const firstErrorKey = Object.keys(this.formErrors)[0];
          if (firstErrorKey) {
            const input = document.querySelector(`[name='${firstErrorKey}']`);
            if (input) {
              input.scrollIntoView({ behavior: 'smooth', block: 'center' });
              input.focus();
            }
          }
        });

        this.$bvToast.toast('Please fix the errors in the form.', {
          title: 'Validation Error',
          variant: 'danger',
          solid: true
        });
        return;
      }
      const roomsPayload = this.rooms.map(room => ({
        ...room,
        guests: room.guests.map(guest => ({
          ...guest,
          passportImageBase64: guest.passportImageBase64 || null
        }))
      }));
      const payload = {
        rooms: roomsPayload,
        arrival: this.arrival,
        preferences: this.preferences,
        emergency: this.emergency,
        payment: this.payment,
        declarations: this.declarations,
        signature: this.signaturePad && !this.signaturePad.isEmpty() ? this.signaturePad.toDataURL('image/png') : this.preCheckinData.signature_data,
        deleteGuests: this.guestsToDelete,
        selected_offer_id: this.selectedOffer?.id || null,
      };
      try {
        const response = await request({
          method: 'post',
          url: `/pre-check-in/${this.$route.params.id}`,
          data: payload,
        });
        this.preCheckinData = response.data;
        this.isPreCheckinSubmitted = true;
        this.isEditing = false;
        await this.fetchBooking();
        this.$bvToast.toast(
          `Pre-checkin updated successfully!`,
          {
            title: "Success",
            variant: "success",
          }
        );
      } catch (error) {
        if (error.request?.status === 422) {
          this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
          return false;
        } else {
          this.formLevelError = 'Failed to update pre-checkin. Please try again.';
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    // Pre-Checkin Offers Methods
    async loadAvailableOffers() {
      this.isLoadingOffers = true;
      try {
        // Get the token from the booking data or route params
        const token = this.booking?.precheckin_token || this.$route.params.id;
        const response = await request({
          method: 'get',
          url: `/pre-check-in/${token}/offers`,
        });
        if (response && response.data) {
          this.availableOffers = response.data.offers || [];
          // If there's a previously selected offer, restore it
          if (response.data.selected_offer) {
            this.selectedOffer = this.availableOffers.find(o => o.id === response.data.selected_offer.id);
          }
        }
      } catch (error) {
        console.error('Failed to load offers:', error);
        this.availableOffers = [];
      } finally {
        this.isLoadingOffers = false;
      }
    },

    selectOffer(offer) {
      // Check if there's already a selected offer
      const previousOffer = this.selectedOffer;

      this.selectedOffer = offer;

      let message = `Offer "${offer.name}" selected!`;
      let title = 'Offer Selected';

      // If there was a previous offer, show different message
      if (previousOffer && previousOffer.id !== offer.id) {
        message = `Offer changed from "${previousOffer.name}" to "${offer.name}"`;
        title = 'Offer Updated';
      }

      this.$bvToast.toast(message, {
        title: title,
        variant: 'success',
        solid: true
      });
    },

    clearSelectedOffer() {
      this.selectedOffer = null;
      this.$bvToast.toast('Offer removed', {
        title: 'Offer Removed',
        variant: 'info',
        solid: true
      });
    },

    calculateOfferDiscount(offer) {
      if (!offer || !this.booking.total_price) return 0;

      const originalPrice =
        parseFloat(this.booking.total_price) -
        (parseFloat(this.booking.discount_amount) || 0);

      let discount = 0;
      let nights = 0;

      switch (offer.precheckin_discount_type) {
        case 'percentage':
          discount = (offer.value / 100) * originalPrice;
          discount = offer.max_discount
            ? Math.min(discount, offer.max_discount)
            : discount;
          break;
        case 'fixed':
          discount = Math.min(offer.value, originalPrice);
          break;
        case 'free_night':
          nights = this.calculateNights();
          discount = nights > 0 ? originalPrice / nights : 0;
          break;
        default:
          discount = 0;
      }

      return parseFloat(discount.toFixed(2)); // ✅ Format to 2 decimal places
    },

    calculateFinalPrice(offer) {
      if (!offer || !this.booking.total_price)
        return parseFloat(this.booking.total_price).toFixed(2);

      const originalPrice =
        parseFloat(this.booking.total_price) -
        (parseFloat(this.booking.discount_amount) || 0);

      const discount = this.calculateOfferDiscount(offer);
      return parseFloat(Math.max(0, originalPrice - discount).toFixed(2)); // ✅ Format to 2 decimal places
    },


    calculateNights() {
      const checkIn = new Date(this.booking.checkin);
      const checkOut = new Date(this.booking.checkout);
      return Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24));
    },

    formatValidUntil(offer) {
      if (!offer.expires_at) return 'No expiration';

      const expiryDate = new Date(offer.expires_at);
      const now = new Date();
      const hoursLeft = Math.ceil((expiryDate - now) / (1000 * 60 * 60));

      if (hoursLeft <= 0) return 'Expired';
      if (hoursLeft < 24) return `${hoursLeft} hours`;
      if (hoursLeft < 48) return `${Math.ceil(hoursLeft / 24)} day`;
      return expiryDate.toLocaleDateString();
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 2rem;
}

.pre-checkin-form-wrapper {
  display: flex;
  justify-content: center;
  padding: 30px 15px;
}

.b-card {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  width: 100%;
  max-width: 1200px;
}

h4 {
  color: #2c3e50;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 18px;
}

.guest-section {
  background: #f8f9fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.doc-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.signature-pad-container {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  min-height: 200px;
  display: flex;
}

.signature-pad {
  display: block;
  width: 100%;
  height: 100%;
  touch-action: none;
}

.signature-display {
  margin-top: 10px;
}

.signature-image {
  border: 1px solid #ced4da;
  border-radius: 4px;
  max-width: 400px;
  max-height: 200px;
  object-fit: contain;
}

/* Read-only view styles */
strong {
  color: #495057;
  font-weight: 600;
}

.text-muted {
  color: #6c757d !important;
  font-style: italic;
}

.section-card {
  background: #f8fafc;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e3e6ea;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  color: #6c757d;
  font-weight: 500;
  font-size: 0.97rem;
}

.value {
  color: #212529;
  font-weight: 600;
  font-size: 1.01rem;
}

.guest-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  padding: 12px 18px;
}

.guest-room-title {
  font-weight: 600;
  color: #3b4252;
  font-size: 1.05rem;
}

.signature-display {
  margin-top: 10px;
  margin-bottom: 10px;
}

.signature-image {
  border: 1px solid #ced4da;
  border-radius: 4px;
  max-width: 400px;
  max-height: 200px;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.guest-cards-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.guest-mini-card {
  background: #f8fafc;
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  padding: 16px 24px;
  min-width: 240px;
  max-width: 320px;
  flex: 1 1 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.guest-mini-header {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1.01rem;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.guest-mini-name {
  font-weight: 600;
  color: #1a202c;
}

.guest-mini-info {
  font-size: 0.97rem;
  color: #495057;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.guest-room-title {
  font-weight: 600;
  color: #3b4252;
  font-size: 1.01rem;
  margin-bottom: 0.3rem;
}

.passport-label {
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 2px;
}

@media (max-width: 768px) {
  .guest-cards-row {
    flex-direction: column;
    gap: 10px;
  }

  .guest-mini-card {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    padding: 12px 10px;
  }
}

/* Pre-Checkin Offers Styles */
.offers-container {
  margin-bottom: 2rem;
}

.offers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.offer-card-compact {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.offer-card-compact:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
  transform: translateY(-1px);
}

.offer-card-compact.offer-selected {
  border-color: #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
}

.offer-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.offer-badge-compact {
  display: inline-block;
  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.offer-content {
  flex-grow: 1;
}

.offer-title-compact {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.3;
  flex-grow: 1;
  margin-right: 0.5rem;
}

.offer-description-compact {
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 1rem;
  margin-bottom: 0.75rem;
}

.offer-pricing {
  background: #f8f9fa;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.75rem;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.price-row:last-child {
  margin-bottom: 0;
  border-top: 1px solid #dee2e6;
  padding-top: 0.25rem;
  margin-top: 0.25rem;
}

.price-label {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
}

.price-original {
  font-size: 0.8rem;
  color: #6c757d;
  text-decoration: line-through;
}

.price-discount {
  font-size: 0.8rem;
  color: #28a745;
  font-weight: 600;
}

.price-final {
  font-size: 1rem;
  color: #007bff;
  font-weight: 700;
}

.offer-validity {
  font-size: 0.75rem;
  color: #6c757d;
  margin-bottom: 1rem;
  text-align: center;
}

.offer-action {
  text-align: center;
  margin-top: auto;
}

.btn-compact {
  width: 100%;
  font-size: 0.85rem;
  padding: 0.375rem 0.75rem;
}

.offer-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.offer-card:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
  transform: translateY(-1px);
}

.offer-selected {
  border-color: #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
}

.offer-header {
  margin-bottom: 12px;
  flex-grow: 1;
}

.offer-badge {
  display: inline-block;
  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.offer-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 6px;
  line-height: 1.3;
}

.offer-description {
  color: #6c757d;
  font-size: 0.85rem;
  line-height: 1.3;
  margin-bottom: 12px;
}

.offer-details {
  margin-bottom: 12px;
}

.offer-price-info {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 8px;
  text-align: center;
}

.original-price {
  color: #6c757d;
  font-size: 0.8rem;
  text-decoration: line-through;
  display: block;
  margin-bottom: 2px;
}

.discount-amount {
  color: #28a745;
  font-weight: 600;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 4px;
}

.final-price {
  color: #007bff;
  font-weight: 700;
  font-size: 1rem;
  display: block;
}

.offer-conditions {
  font-size: 0.75rem;
  color: #6c757d;
  text-align: center;
  margin-bottom: 12px;
}

.offer-actions {
  text-align: center;
  margin-top: auto;
}

.selected-offer-summary {
  border: 1px solid #28a745;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.1);
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
}

.price-breakdown {
  line-height: 1.2;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .offers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .offer-card-compact {
    padding: 0.75rem;
  }

  .offer-title-compact {
    font-size: 0.9rem;
  }

  .offer-description-compact {
    font-size: 0.8rem;
  }

  .offer-badge-compact {
    font-size: 0.65rem;
    padding: 3px 6px;
  }

  .offer-pricing {
    padding: 0.5rem;
  }

  .price-row {
    font-size: 0.75rem;
  }

  .btn-compact {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
}

.selected-offer-summary {
  border: 2px solid #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
}

.price-breakdown {
  font-size: 0.9rem;
}

.price-breakdown .text-decoration-line-through {
  text-decoration: line-through;
}

.price-breakdown .text-success {
  color: #28a745 !important;
}

.price-breakdown .text-primary {
  color: #007bff !important;
}

@media (max-width: 768px) {
  .offer-card {
    padding: 15px;
  }

  .offer-title {
    font-size: 1rem;
  }

  .offer-badge {
    font-size: 0.8rem;
    padding: 4px 10px;
  }
}

/* Editing mode badge */
.badge-info {
  background-color: #17a2b8;
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}

.badge-info i {
  margin-right: 0.25rem;
}

.offer-previously-applied {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0.25rem 0.5rem;
  background-color: #f8fff9;
  border-radius: 4px;
  border: 1px solid #d4edda;
}

.offer-previously-applied i {
  color: #28a745;
  font-size: 0.8rem;
}

.offer-previously-applied small {
  font-size: 0.75rem;
  color: #6c757d;
}
</style>
